import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { registerUser, logout } from './authSlice';
import { Form, Button, Container } from 'react-bootstrap';
import { useNavigate, Link } from 'react-router-dom';

import 'bootstrap/dist/css/bootstrap.min.css'; // Make sure Bootstrap CSS is imported
import '../custom_styles.css';

export default function Register() {
  const [form, setForm] = useState({ email: '', password: '' });
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loading, status, error } = useSelector((state) => state.auth);

  const handleSubmit = async (e) => {
      e.preventDefault();
      const result = await dispatch(registerUser(form));
      if (registerUser.fulfilled.match(result)) {
          // pass email via navigation state or query param
          navigate('/verify-email', { state: form });
      }
  };
  useEffect(() => {
        dispatch(logout());
  }, []);

  return (
    <Container className="mt-5" style={{ maxWidth: '400px' }}>
      <h3>Register</h3>
      <Form onSubmit={handleSubmit}>
        <Form.Group className="mb-3">
          <Form.Label>Email</Form.Label>
          <Form.Control
              type="email"
              value={form.email}
              onChange={(e) => setForm({...form, email: e.target.value})}
              required/>
        </Form.Group>
        <Form.Group className="mb-3">
          <Form.Label>Password</Form.Label>
          <Form.Control
              type="password"
              value={form.password}
              onChange={(e) => setForm({...form, password: e.target.value})}
              required/>
        </Form.Group>
        <Button className="ms-2 btn-primary fw-bold" type="submit" disabled={loading || status === 'loading'}>
           {status === 'loading' ? 'Creating...' : 'Sign Up'}
        </Button>
        <Button as={Link} to="/login" className="btn-missed-path-2">
          Already Registered?<br />Sign In
        </Button>
        {error && <p className="text-danger mt-2">{error}</p>}
      </Form>
    </Container>
  );
}

